const initialState = {
    refreshCompanyTable:'',
    searchCompanyValue:'',
};
export const actionTypes = {
    REFRESH_COMPANY_TABLE: "REFRESH_COMPANY_TABLE",
    SEARCH_COMPANY_TABLE:"SEARCH_COMPANY_TABLE",
};

export const actions = {
    refresh_company_table: function (data) {
        return {
            type: actionTypes.REFRESH_COMPANY_TABLE,
            data
        }
    },
    search_company_table: function (data) {
        return {
            type: actionTypes.SEARCH_COMPANY_TABLE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_COMPANY_TABLE:{
            return {...state,refreshCompanyTable:action.data}
        }
        case actionTypes.SEARCH_COMPANY_TABLE:{
            return {...state,searchCompanyValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/companyReducer.js